export const themeColorNames = [
  'primary',
  'secondary',
  'background',
  'block-background',
  'disabled',
  'header-background',
  'header-text',
] as const

type ThemeKeysType = (typeof themeColorNames)[number]

export type ThemeValueType = string

type CSSVariableType = string

export type ThemeInterface = Partial<Record<ThemeKeysType, ThemeValueType>>

export type MappedThemeInterface = Record<CSSVariableType, ThemeValueType>

export type AdditionalColorsType = Record<
  string,
  { baseColor: keyof ThemeInterface; opacity?: number }
>
